import { LuLoaderCircle } from "react-icons/lu";

import { cn } from "@/lib/utils";

function Spinner({ className, ...props }: React.ComponentProps<typeof LuLoaderCircle>) {
  return (
    <LuLoaderCircle
      className={cn("size-4 animate-spin", className)}
      data-slot="spinner"
      {...props}
    />
  );
}

export { Spinner };
